import { render, staticRenderFns } from "./Auth1.vue?vue&type=template&id=bd2cfed8&"
import script from "./Auth1.vue?vue&type=script&lang=js&"
export * from "./Auth1.vue?vue&type=script&lang=js&"
import style0 from "./Auth1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports